module.exports = __webpack_public_path__ + "media/images/icons/dropdown-05a82ff8de9fd99e50a35fbeb1f96425.svg";